//---------------------------------------------
// Municipios Module 
//---------------------------------------------
// Módulo para gerenciar os municipios

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    regional: [], 
    municipios: []
})

// MUTATIONS
const mutations = {
    //-- MUTATION PARA ALTERAR ESTADO DOS MUNICIPIOS
    setMunicipios(state, payload) {
        state.municipios = payload
    },

    //-- MUTATION PARA ALTERAR ESTADO DA REGIONAL
    setRegional(state, payload) {
        state.regional = payload
    },
}

// ACTIONS
const actions = {
    //-- ACTION PEGAR REGIONAL POR MUNICIPIO
    async setRegionalByMunicipio({ commit }, payload) {
        await axios
            .get(`/municipios/get-regional/${payload.id_municipio}`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setRegional', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTFORMS
    async setMunicipios({ commit },) {
        await axios
            .get(`/municipios/listMunics`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setMunicipios', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTFORMS
    async setUserMunicipios({ commit },) {
        await axios
            .get(`/municipios/listUserMunics`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setMunicipios', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTFORMS
    async setRegionalMunicipios({ commit }, payload) {
        await axios
            .get(`/municipios/by-regional/${payload.id_regional}`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setMunicipios', response.data)
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getMunicipios(state) {
        try {
            return state.municipios.data
        } catch (e) {
            return []
        }
    },

    getRegional(state) {
        try {
            return state.regional.data
        } catch (e) {
            return []
        }
    },

}

export default {
    state,
    mutations,
    actions,
    getters
}
